export enum AdminScopes {
  VIEW_DASHBOARD = 'view.dashboard',
  VIEW_USERS = 'view.users',
  VIEW_USERS_LOGIN = 'view.users.login',
  VIEW_USERS_SETTINGS = 'view.users.settings',
  VIEW_USERS_SETTINGS_BILLING = 'view.users.settings.billing',
  VIEW_USERS_SETTINGS_COMPANY_CHARGES = 'view.users.settings.company_charges',
  VIEW_USERS_SETTINGS_TIER = 'view.users.settings.tier',
  VIEW_USERS_SETTINGS_PAYMENT_TYPE = 'view.users.settings.payment_type',
  VIEW_USERS_SETTINGS_MACHOOL_PICKUP = 'view.users.settings.machool_pickup',
  VIEW_USERS_SETTINGS_NOTES = 'view.users.settings.notes',
  VIEW_USERS_SETTINGS_SALES = 'view.users.settings.sales',
  VIEW_USERS_SETTINGS_COURIERS = 'view.users.settings.couriers',
  VIEW_USERS_SETTINGS_COURIER_MODIFIERS = 'view.users.settings.courier_modifiers',
  VIEW_USERS_SETTINGS_DYNAMIC_PRICING = 'view.users.settings.dynamic_pricing',
  VIEW_USERS_SETTINGS_WALLET_TRANSACTIONS = 'view.users.settings.wallet_transactions',
  VIEW_USERS_SETTINGS_COMPANY_SETTINGS = 'view.users.settings.company_settings',
  MODIFY_DASHBOARD = 'modify.dashboard',
  MODIFY_DASHBOARD_ZONES = 'modify.dashboard.zones',
  MODIFY_DASHBOARD_CARDS = 'modify.dashboard.cards',
  MODIFY_USERS = 'modify.users',
  MODIFY_USERS_CLOSE_COMPANY = 'modify.users.close_company',
  MODIFY_USERS_CHANGE_COMPANY_OWNER = 'modify.users.change_company_owner',
  MODIFY_USERS_SETTINGS = 'modify.users.settings',
  MODIFY_USERS_SETTINGS_BILLING = 'modify.users.settings.billing',
  MODIFY_USERS_SETTINGS_COMPANY_CHARGES = 'modify.users.settings.company_charges',
  MODIFY_USERS_SETTINGS_BILLING_INVOICES = 'modify.users.settings.billing.invoices',
  MODIFY_USERS_SETTINGS_TIER = 'modify.users.settings.tier',
  MODIFY_USERS_SETTINGS_PAYMENT_TYPE = 'modify.users.settings.payment_type',
  MODIFY_USERS_SETTINGS_MACHOOL_PICKUP = 'modify.users.settings.machool_pickup',
  MODIFY_USERS_SETTINGS_NOTES = 'modify.users.settings.notes',
  MODIFY_USERS_SETTINGS_SALES = 'modify.users.settings.sales',
  MODIFY_USERS_SETTINGS_COURIER_MODIFIERS = 'modify.users.settings.courier_modifiers',
  MODIFY_USERS_SETTINGS_DYNAMIC_PRICING = 'modify.users.settings.dynamic_pricing',
  MODIFY_USERS_SETTINGS_WALLET_TRANSACTIONS = 'modify.users.settings.wallet_transactions',
  MODIFY_USERS_SETTINGS_COMPANY_SETTINGS = 'modify.users.settings.company_settings',
  VIEW_SHIPMENTS = 'view.shipments',
  VIEW_SHIPMENTS_DETAILS = 'view.shipments.details',
  VIEW_RECONCILIATION = 'view.reconciliation',
  VIEW_SERVICE_BUILDER = 'view.service_builder',
  VIEW_NOTIFICATIONS = 'view.notifications',
  VIEW_CANCELLATIONS = 'view.cancellations',
  VIEW_INSURANCE_CLAIMS = 'view.insurance_claims',
  VIEW_REPORTS = 'view.reports',
  VIEW_INVOICES = 'view.invoices',
  VIEW_INVOICES_LIST = 'view.invoices.list',
  VIEW_INVOICES_CUSTOMERS = 'view.invoices.customers',
  MODIFY_INVOICES_LIST = 'modify.invoices.list',
  MODIFY_INVOICES_CUSTOMERS = 'modify.invoices.customers',
  VIEW_MACHOOL_REPORTS = 'view.reports.machool',
  VIEW_REPORTS_CARDS = 'view.reports.cards',
  VIEW_REPORTS_CARD_DATA = 'view.reports.card_data',
  VIEW_REPORTS_TOP_REVENUE = 'view.reports.top_revenue',
  VIEW_REPORTS_TOP_COURIERS = 'view.reports.top_couriers',
  VIEW_ACC_REPORTS = 'view.reports.acc',
  VIEW_SCAN_EVENTS = 'view.scan_events',
  // User with combination of 2 scopes will see everything (as we are seeing now) + no Export CSV
  VIEW_SCAN_EVENTS_SORTS = 'view.scan_events.sorts',
  VIEW_SCAN_EVENTS_PICKUPS = 'view.scan_events.pickups',
  // Apple User with combination of 2 scopes will see everything except $ data points related + No Export CSV
  VIEW_SCAN_EVENTS_SORTS_APPLEEXPRESS = 'view.scan_events.sorts.appleexpress',
  VIEW_SCAN_EVENTS_PICKUPS_APPLEEXPRESS = 'view.scan_events.pickups.appleexpress',
  // Export CSV
  MODIFY_SCAN_EVENTS_SORTS = 'modify.scan_events.sorts',
  MODIFY_SCAN_EVENTS_PICKUPS = 'modify.scan_events.pickups',
  VIEW_API_KEYS = 'view.api_keys',
  MODIFY_SHIPMENTS = 'modify.shipments',
  MODIFY_SHIPMENTS_RETURN_LABEL = 'modify.shipments.return_label',
  MODIFY_RECONCILIATION = 'modify.reconciliation',
  MODIFY_SERVICE_BUILDER = 'modify.service_builder',
  MODIFY_NOTIFICATIONS = 'modify.notifications',
  MODIFY_CANCELLATIONS = 'modify.cancellations',
  MODIFY_INSURANCE_CLAIMS = 'modify.insurance_claims',
  MODIFY_REPORTS = 'modify.reports',
  MODIFY_API_KEYS = 'modify.api_keys',
  VIEW_MANIFESTS = 'view.manifests',
  MODIFY_MANIFESTS = 'modify.manifests',
  VIEW_COURIERS = 'view.couriers',
  MODIFY_COURIERS = 'modify.couriers',
  LIMIT_RIVO = 'limit.rivo',
  LIMIT_UNIUNI = 'limit.uniuni',
  VIEW_UNBILLABLE_SHIPMENTS = 'view.unbillable_shipments',
  VIEW_UNKNOWN_TRACKING = 'view.unknown_tracking',
  MODIFY_UNKNOWN_TRACKING = 'modify.unknown_tracking',
  VIEW_PLATFORMS = 'view.platforms',
  MODIFY_PLATFORMS = 'modify.platforms',
  MODIFY_STATUS = 'modify.status',
  VIEW_FINANCE = 'view.finance',
  MODIFY_FINANCE = 'modify.finance',
  VIEW_PERMISSIONS = 'view.permissions',
  MODIFY_PERMISSIONS = 'modify.permissions',
  VIEW_CLAIMS = 'view.claims',
  VIEW_CLAIMS_FINANCE = 'view.claims.finance',
  MODIFY_CLAIMS = 'modify.claims',
  VIEW_CONFIGURATION = 'view.configuration',
  MODIFY_CONFIGURATION = 'modify.configuration',
  VIEW_OTP = 'view.otp',
  MODIFY_OTP = 'modify.otp',
  VIEW_SITE_TOURS = 'view.site_tours',
  MODIFY_SITE_TOURS = 'modify.site_tours',
  VIEW_AWB_LABELS = 'view.awb_labels',
  MODIFY_AWB_LABELS = 'modify.awb_labels',
  VIEW_AWB_PICKUPS = 'view.awb_pickups',
  VIEW_AWB_PICKUPS_UNIUNI = 'view.awb_pickups.uniuni',
  VIEW_AWB_PICKUPS_INTELCOM = 'view.awb_pickups.intelcom',
  VIEW_AWB_PICKUPS_CANADA_POST = 'view.awb_pickups.canadapost3pl',
  MODIFY_SHIPMENTS_ARCHIVE = 'modify.shipments.archive',
  VIEW_FRAUD_DETECTION = 'view.fraud_detection',
  MODIFY_FRAUD_DETECTION = 'modify.fraud_detection',
  VIEW_RATING_TOOL='view.rating_tool',
  VIEW_SSO_CONNECTIONS = 'view.sso_connections',
  MODIFY_SSO_CONNECTIONS = 'modify.sso_connections',
}
